export default __webpack_public_path__ + "static/media/Creditos-PT.fc5fcb1f.png";